// extracted by mini-css-extract-plugin
export default {"container":"Board_container__7tFkA","columnsContainer":"Board_columnsContainer__crEFO","columns":"Board_columns__lrO90","createButton":"Board_createButton__coKrO"};